import { useMutation } from 'react-query';

import {
    QueryParams,
    QueryResponse,
    createNewTemplateFromReport as mutationFn,
} from 'api/endPoints/CreateNewTemplateFromReport';

export const useMutationCreateTemplateFromReport = () => {
    return useMutation<QueryResponse, QueryError, QueryParams>((params) => mutationFn(params));
};
